import transformSvg from "../../assets/image/Transform Your Recruitment Workflow.svg";

const FooterTransformHeading = () => {
  const updateGlowPosition = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - bounds.left) / bounds.width) * 100;
    const y = ((event.clientY - bounds.top) / bounds.height) * 100;

    event.currentTarget.style.setProperty("--glow-x", `${x}%`);
    event.currentTarget.style.setProperty("--glow-y", `${y}%`);
  };

  return (
    <div
      className="footer-transform-heading relative mx-auto w-full"
      style={{ maxWidth: "754px" }}
      onPointerEnter={updateGlowPosition}
      onPointerMove={updateGlowPosition}
    >
      <img
        src={transformSvg}
        alt=""
        aria-hidden="true"
        className="relative z-0 block h-auto w-full"
        style={{ opacity: 0.42, maxWidth: "754px" }}
        decoding="async"
      />
      <div
        className="footer-transform-shine pointer-events-none absolute inset-0 z-[1]"
        style={{
          WebkitMaskImage: `url(${transformSvg})`,
          maskImage: `url(${transformSvg})`,
          WebkitMaskSize: "100% 100%",
          maskSize: "100% 100%",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
        }}
        aria-hidden="true"
      />
    </div>
  );
};

export default FooterTransformHeading;
